
import FFormSubmitBtnMDP from "@/components/FFormSubmitBtnMDP";
import FFormDrawerMDP, { FFormChildMDP } from "@/components/form/FFormDrawerMDP";
import FFormMDP from "@/components/form/FFormMDP";
import FEmailFieldMDP from "@/components/form/field/FEmailFieldMDP";
import FPhoneFieldMDP from "@/components/form/field/FPhoneFieldMDP";
import FSwitchMDP from "@/components/form/field/FSwitchMDP";
import FTextareaMDP from "@/components/form/field/FTextareaMDP";
import FTextFieldMDP from "@/components/form/field/FTextFieldMDP";
import FSearchGridMDP from "@/components/generic/FSearchGridMDP";

export default class ClientFileDetailsFFormMDP extends FFormDrawerMDP {
    childMDP: FFormChildMDP = new FFormChildMDP();
    constructor(props: { parent: any; onClose: () => void; isVisible: boolean }) {
        super({ myRefName: "ClientFileDetailsFFormRef", isVisible: props.isVisible, onClose: props.onClose, width: "60%", readonly: true, disabled: true, title: "Customer Details" });
        this.addField(new FTextFieldMDP({
            dataSelectorKey: "customerFullName",
            label: "Name",
            parentMDP: this.childMDP,
            boundaryClass: "col-4",
            readonly: true
        }))

            .addField(new FTextFieldMDP({
                dataSelectorKey: "clientFileNumber",
                label: "ClientFile Number",
                parentMDP: this.childMDP,
                boundaryClass: "col-4",
                readonly: true
            }))

            .addField(new FTextFieldMDP({
                dataSelectorKey: "clientFileStatus",
                label: "ClientFileStatus",
                parentMDP: this.childMDP,
                boundaryClass: "col-4",
                readonly: true
            }))

            .addField(new FSwitchMDP({
                dataSelectorKey: "eMandateActive",
                label: "Emandate Status",
                parentMDP: this.childMDP,
                boundaryClass: "col-4",
                
            }))


        if (props.parent.customerDetails.hardshipReason) {
            this.addField(new FTextareaMDP({
                dataSelectorKey: "hardshipReason",
                label: "Hardship Reason",
                parentMDP: this.childMDP,
                boundaryClass: "col-4",
                disabled: true
            }))
        }


        this.addField(new FTextFieldMDP({
            dataSelectorKey: "ppCode",
            label: "PP Code",
            parentMDP: this.childMDP,
            boundaryClass: "col-4",
            mandatory: true,
            readonly: true
        }))


            .addField(new FTextFieldMDP({
                dataSelectorKey: "city",
                label: "City",
                parentMDP: this.childMDP,
                boundaryClass: "col-4",
                mandatory: true,
                readonly: true
            }))

            .addField(new FTextFieldMDP({
                dataSelectorKey: "state",
                label: "State",
                parentMDP: this.childMDP,
                boundaryClass: "col-4",
                mandatory: true,
                readonly: true
            }))

            .addField(new FTextFieldMDP({
                dataSelectorKey: "pinCode",
                label: "PIN Code",
                parentMDP: this.childMDP,
                boundaryClass: "col-4",
                mandatory: true,
                readonly: true
            }))
    }
}